import { render, staticRenderFns } from "./News.vue?vue&type=template&id=2b4b37d5&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/news.css?vue&type=style&index=0&id=2b4b37d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b37d5",
  null
  
)

export default component.exports